/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import { dimensions } from "./variables";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const headerHeight = dimensions.header.height.desktop;
const mobileHeaderHeight = dimensions.header.height.mobile;

export const StyledHeaderIcon = styled(AccountCircleIcon)`
  ${({ theme }) => `
    color: ${theme.palette.text.secondary};
    vertical-align: middlssse;

    &:hover {
      color: ${theme.palette.primary.main};
    }
  `}
`;

const StyledHeader = styled.header`
  ${({ theme }) => `
  background-color: #F4F4F4;
  box-shadow: 0px 3px 4px 0px ${theme.palette.text.disabled};
  position: relative;
  z-index: 20;

  ${theme.breakpoints.down("sm")} {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
  }

  .header-topbarSection {
    height: ${headerHeight}px;
    width: auto;

    ${theme.breakpoints.down("sm")} {
      height: ${mobileHeaderHeight}px;
    }
  }

  ${theme.breakpoints.down("sm")} {
    .header-mobile-topbar {
      justify-content: center;
    }

    .container-mobile-cart {
      cursor: pointer;
      display: flex;
      align-items: center;
      /* Posicionado igual que las hamburguesas (absoluto respecto al header),
         a la izquierda de la hamburguesa derecha, para no afectar el centrado
         del logo. */
      position: absolute;
      z-index: 50;
      top: 17px;
      right: 52px;

      .badge-cart .MuiBadge-colorSecondary {
        color: #fff;
        background-color: #d14e4e;
      }

      .iconCarritoMobile {
        color: #2b2c30;
        font-size: 26px;
        vertical-align: middle;
      }
    }
  }

  .welcome-text {
    text-align: left;
    .MuiTypography-button {
      color: ${theme.palette.text.primary};
    }

    .MuiTypography-root {
      line-height: 1.5;
    }
  }

  .header-actionsButton {
    padding: ${theme.spacing(1)}px;

    &.header-actionsButton-languageToggle .MuiTypography-body1 {
      line-height: 26px;
    }
  }

  .header-branding {
    a {
      display: block;
      line-height: 1;
    }

    img {
      height: 43px;
      width: 192px;
    }

    ${theme.breakpoints.down("sm")} {
      img {
        height: 20px;
      }
    }

    @media (max-width: 450px) {
      margin-left: 0px;
    }
  }

  .header-links {
    text-align: right;
    ${theme.breakpoints.up("sm")} {
      padding: 0 ${theme.spacing(2)}px;
    }
  }

  .menu-hamburger {
    background: none;
    border: 0;
    margin: 0;
    padding: 0;

    &:hover {
      color: ${theme.palette.primary.dark};
      cursor: pointer;
    }

    .MuiSvgIcon-root {
      vertical-align: middle;
    }
  }

  .menu-container {
    display: none;

    &.open {
      display: flex;
    }
  }

  .expanded-menu-container{
    background-color: ${theme.palette.primary.main};
    line-height: normal;
    position: relative;
    color: ${theme.palette.text.expandedMenu};
    text-align: left;
    z-index: -1;
    &.hover {
      .MuiBox-root {
        background-color:${theme.palette.background.paper};
      }
    }
  }

  .MuiTypography-body2 {
    display: inline-block;
  }

  #signin_link,
  #myaccount_link,
  #cart_link {
    color: ${theme.palette.text.primary};
    text-decoration: none;

    &:visited {
      color: ${theme.palette.text.primary};
    }

    &:hover {
      color: ${theme.palette.primary.main};

      .MuiSvgIcon-root {
        color: ${theme.palette.primary.main};
      }
    }

    .MuiSvgIcon-root {
      color: ${theme.palette.text.primary};
      vertical-align: middle;
      font-size: 1.3rem;
    }
  }

  .menu-container {
    position: absolute;
    z-index: 3;
    background: white;
    width: 100%;
    margin: 0;
    left: 0;
    border-top: 1px solid ${theme.palette.action.disabledBackground};
    box-shadow: 0px 3px 4px 0px ${theme.palette.text.disabled};
    top: ${headerHeight}px;

    ${theme.breakpoints.down("sm")} {
      top: ${mobileHeaderHeight}px;
      width: 500px;
    }
  }
  .separador{
    /*padding-left: 5vw;
    padding-right: 4vw;
    border-left: solid 1px #000;
    border-right: solid 1px #000;
    margin-left: 20px;*/
    
  }

  .separadorHeader {
    position: relative;
  }

  @media (max-width: 700px) {
    .separadorCuenta {
      display: none;
    }
    .separadorHeader:before {
      border-right: unset !important;
    }
  }

  
  .separadorHeader:before {
    content: "";
    border: 0px;
    border-right: solid 1px #000;
    right: -20px;
    position: absolute;
    top: 0px;
    height: 36px;
    top: 12px;
  }

  .separadorCuenta {
    position: relative;
  }
  .separadorCuenta:before {
    content: "";
    border: 0px;
    border-left: solid 1px #000;
    left: -20px;
    position: absolute;
    top: 0px;
    height: 36px;
    top: 14px;
  }
  /*.sc-gWXbKe.dswSso::before {
    content: "";
    border: 0px;
    border-left: solid 1px red;
    left: 0px;
    position: absolute;
    top: 0px;
    height: 26px;
    top: 8px;
  }*/
  .minishopcart_total{
    background: #fff;
    color: #000;
    font-size: 11px;
    width: auto;
    border-radius: 100%;
    position: absolute;
    left: 6px;
    display: inline-block;
    right: auto;
    top: 1px;
    padding: 0px 4px;
    z-index: 1;
  }
  .header-menu {
    .MuiDrawer-paperAnchorTop {
      margin-top: ${headerHeight}px;
    }
  }
  `}
`;

export { StyledHeader };
